import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/hooks/useAuth';
import { getAuthBypassState } from '@/lib/authBypass';
import type { UserProfile } from '@/types/storage';

interface UseProfileResult {
  profile: UserProfile | null;
  loading: boolean;
  error: string | null;
}

export function useProfile(): UseProfileResult {
  const { session } = useAuth();
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const bypassState = getAuthBypassState();
    if (bypassState) {
      setProfile(bypassState.profile);
      setError(null);
      setLoading(false);
      return;
    }

    if (!session?.user.id) {
      setProfile(null);
      setLoading(false);
      return;
    }

    const userId = session.user.id;
    setLoading(true);

    supabase
      .from('profiles')
      .select('id, school_id, district_id, is_pro, is_super_admin, user_status, district_gate_exempt')
      .eq('id', userId)
      .maybeSingle()
      .then(({ data, error: fetchError }) => {
        if (fetchError) {
          setError(fetchError.message);
        } else {
          setProfile(data);
        }
        setLoading(false);
      });
  }, [session?.user.id]);

  return { profile, loading, error };
}
